import React from 'react';
import { Group } from '@mantine/core';
import useTranslation from 'next-translate/useTranslation';

import { EO_BRANDS } from '~/domains/auth/consts';
import { Text } from '~/domains/design-system/Text';
import { VectorOFPlogo } from '~/domains/design-system/vectors/VectorOFPlogo';
import { VectorRYPlogo } from '~/domains/design-system/vectors/VectorRYPlogo';

import useStyles from './ContestRestartCard.styles';

function ContestInviteCardSourceInfo({ source }: { source: keyof typeof EO_BRANDS }) {
  const { theme } = useStyles();
  const { t } = useTranslation('contest');

  return (
    <Group spacing={theme.other.spacing._4}>
      <Text variant="title-small" color={theme.colors.gray2[3]}>
        {t('common.contestRestartCard.sourceInfo.moved')}
      </Text>
      {source === EO_BRANDS.RYP && <VectorRYPlogo color={theme.colors.gray2[3]} height={16} />}
      {source === EO_BRANDS.OFP && <VectorOFPlogo color={theme.colors.gray2[3]} height={16} />}
    </Group>
  );
}

export default ContestInviteCardSourceInfo;
